import { Component } from '@verndale/core';

class imageFlag extends Component {
  setupDefaults() {
    this.dom = {
      $imageFlagItems: this.el.querySelectorAll('.image-flag__item'),
    };

    this.changeColor();
  }

  addListeners() {

  }

  changeColor(){
    this.dom.$imageFlagItems.forEach((item) => {
      const customColor = item.getAttribute('data-color');
      if (customColor) {
        item.style.setProperty('--custom-image-flag-bg-color', customColor);
      }
    });
  }
}

export default imageFlag;
